<a *ngIf="sumOfElements" [ngbTooltip]="elemets" class="link"
   tooltipClass="widthFix">{{ sumOfElements|sbNumberFormat }} {{ (sumOfElements > 1 ? 'lang.globals.elements' : 'lang.globals.element') |translate }}</a>
<span *ngIf="!sumOfElements"
      [innerHTML]="'lang.planning.completePlanning'|translate"></span>
<ng-template #elemets>
  <div style="width: 300px">

    <ul>
      <li class="tw-flex-nowrap">{{ 'lang.globals.campaigns' |translate }}: {{ submission?.selectedCampaignsCount ?? 0| sbNumberFormat }}
      </li>
      <li class="tw-flex-nowrap">{{ 'lang.globals.commercials' |translate }}
        : {{ submission?.selectedCommercialsCount ?? 0| sbNumberFormat }}
      </li>
      <li class="tw-flex-nowrap">{{ 'lang.globals.requirements' |translate }}
        : {{ submission?.selectedRequirementsCount ?? 0| sbNumberFormat }}
      </li>
      <li class="tw-flex-nowrap">{{ 'lang.globals.contentShares' |translate }}
        : {{ submission?.selectedContentSharesCount ?? 0| sbNumberFormat }}
      </li>
    </ul>
  </div>
</ng-template>
